/**
 * Wave 6 / Phase 3.11 — Archive scale counters.
 *
 * Visible "expanding intelligence system" signal across the entire
 * research library: investigations + Research Explorer collections
 * (vaccines, diseases, manufacturers). Each tile deep-links to the
 * relevant browse surface so the homepage acts as a dashboard for the
 * growing library.
 *
 * Designed to scale: as new explorers (Medicines, Food Additives,
 * Chemicals…) ship, add their slug + endpoint count here without
 * redesigning the component.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

function fmt(n) {
    return typeof n === "number" ? n.toLocaleString("en-US") : "—";
}

const ITEMS = [
    { key: "complete_investigations", label: "Investigations", to: "/" },
    { key: "vaccines_indexed",        label: "Vaccines indexed", to: "/vaccines" },
    { key: "diseases_covered",        label: "Diseases covered", to: "/entities?type=disease" },
    { key: "manufacturers_indexed",   label: "Manufacturers",    to: "/entities?type=manufacturer" },
    { key: "indexed_sources",         label: "Indexed sources",  to: "/sources" },
    { key: "linked_entities",         label: "Linked entities",  to: "/entities" },
    { key: "timeline_events",         label: "Documented events", to: "/timeline" },
    { key: "under_investigation",     label: "Under investigation", to: "/" },
];

export default function ArchiveScaleCounter({ className = "" }) {
    const [stats, setStats] = useState(null);
    useEffect(() => {
        let cancelled = false;
        api.get("/archive-stats")
            .then((r) => { if (!cancelled) setStats(r.data); })
            .catch(() => { /* silent — counters are decorative */ });
        return () => { cancelled = true; };
    }, []);
    return (
        <div
            data-testid="archive-scale-counter"
            className={`grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-x-6 gap-y-6 ${className}`}
        >
            {ITEMS.map((it) => (
                <Link
                    key={it.key}
                    to={it.to}
                    data-testid={`archive-stat-${it.key}`}
                    className="border-l border-[#243044] pl-4 group transition-colors hover:border-[#56CCF2]"
                >
                    <div className="text-2xl sm:text-[28px] font-bold text-white tracking-tight tabular-nums leading-none mb-1.5 group-hover:text-[#56CCF2] transition-colors">
                        {stats ? fmt(stats[it.key]) : "—"}
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.22em] text-[#64748B] font-medium leading-tight group-hover:text-[#94A3B8] transition-colors">
                        {it.label}
                    </div>
                </Link>
            ))}
        </div>
    );
}
